import React, { useEffect } from 'react';
import { useAppContext } from '../../../AppContext';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Navigation } from '../../../logic/components';
import styles from './MainLayout.module.scss';
import Footer from './Footer';
import { StyleService } from '../../services';
import { useAuthenticationContext } from '../../services/AuthenticationProvider';
import { DictionaryType } from '../../types/DictionaryType';
import GlobalConfig from '../../api/GlobalConfig';

type PropsType = {
  children: React.ReactNode;
};

const MainLayout = (props: PropsType) => {
  const context = useAppContext();
  const generalStyles = StyleService.applyMany(
    [
      'module:header',
      'module:header:logo',
      'module:header:navbar',
      'module:header:pagename',
      'general:colors',
    ],
    context.styles
  );
  const authContext = useAuthenticationContext();

  useEffect(() => {
    const faviconData = StyleService.apply('general:favicon', context.styles);

    StyleService.makeFaviconTag(faviconData.favicon);
  }, []);

  return (
    <Main styles={context.styles} className={styles.wrapper}>
      <HeaderDiv styles={generalStyles['module:header']} className={styles.headerWrapper}>
        <div className={classNames('container', styles.header)}>
          <div className={styles.group}>
            <div className={classNames(styles.groupItem, styles.logo)}>
              <Link className={styles.logoLink} to="/" title={`v${GlobalConfig.val().Version}`}>
                <img
                  src={
                    generalStyles['module:header:logo'].backgroundImage ||
                    require('../../../assets/images/logo.svg').default
                  }
                  className={classNames(styles.logoImage)}
                  alt="MyPage"
                />
              </Link>
            </div>

            <div className={classNames(styles.groupItem, styles.groupItemNavigation)}>
              {authContext && !!authContext.isAuthenticated ? (
                /* @ts-ignore */
                <Navigation />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </HeaderDiv>

      {props.children}

      <Footer />
    </Main>
  );
};

const Main = styled.div<{ styles: DictionaryType<DictionaryType<string>> }>`
  ${(props) => {
    let styles = '';

    if (props.styles['general:colors'].textColor) {
      styles = `color: ${props.styles['general:colors'].textColor}; ${styles}`;
    }

    if (props.styles['general:colors'].linkColor) {
      styles = `a { color: ${props.styles['general:colors'].linkColor}; } ${styles}`;
    }

    return css`
      ${styles}
    `;
  }}
`;

const HeaderDiv = styled.header<{ styles: DictionaryType<string> }>`
  ${(props) => {
    return (
      props.styles.backgroundColor &&
      css`
        --header-background-color: ${props.styles.backgroundColor};
      `
    );
  }}
`;

const StyledPageName = styled.span<{ styles: DictionaryType<string> }>`
  ${(props) =>
    props.styles.textColor &&
    css`
      --header-text-color: ${props.styles.textColor};
    `}
`;

export default React.memo(MainLayout);
